// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-213377d4] {\n  font-size: 16px;\n  font-weight: 500;\n  color: #186bfc;\n  padding: 32px 0 16px;\n  width: 100%;\n}\n.h300[data-v-213377d4] {\n  height: 300px;\n}\n.w50[data-v-213377d4] {\n  width: 50%;\n}\n.w25[data-v-213377d4] {\n  width: 25%;\n}\n", ""]);
// Exports
module.exports = exports;
